import modalReducer from "@linkfluence/core/modal/reducer";
import panelReducer from "@linkfluence/core/panel/reducer";
import { Key } from "@linkfluence/core/state";

export default {
  [Key.Panel]: panelReducer,
  [Key.Modal]: modalReducer,
};
